import React, { useEffect, useState } from "react";
import { ModalsKeys } from "global";
import { useModal } from "hooks/useModal";
import { Box, CircularProgress, Dialog, DialogContent, Fade, Stack, Typography } from "@mui/material";

const steps = ["We create an opportunity for you...", "We add equipment to our system...", "Create a proposal..."];
const INTERVAL_STEP = 7000;

export const ProposalCreationModal = () => {
  const { isOpen, handleClose } = useModal(ModalsKeys.ProposalCreationDialog);

  const [stepIndex, setStepIndex] = useState(0);

  useEffect(() => {
    setStepIndex(0);

    const interval = setInterval(() => {
      setStepIndex(prev => (prev + 1 < steps.length ? prev + 1 : prev));
    }, INTERVAL_STEP);

    return () => clearInterval(interval);
  }, [isOpen]);

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={isOpen}
      disableEscapeKeyDown
      onClose={(_, reason) => {
        if (reason !== "backdropClick") handleClose();
      }}>
      <DialogContent>
        <Stack justifyContent="center" alignItems="center" gap="1rem">
          <CircularProgress />

          <Box>
            <Fade in key={stepIndex} timeout={500}>
              <Typography align="center" variant="subtitle2">
                {steps[stepIndex]}
              </Typography>
            </Fade>
          </Box>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
